import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'
import type { DispositifDR } from './DispositifDR'

export const DispositifDRLibelle: UnionTypeLibelle<DispositifDR> = {
  CPRO: 'Contrat de professionnalisation',
  PROA: 'Reconversion ou promotion par alternance',
  AF: 'Action de formation',
  FPE: 'FPE',
} as const

export const DispositifDRLibelleCreation: UnionTypeLibelle<DispositifDR> = {
  CPRO: 'Nouveau contrat de professionnalisation',
  PROA: 'Nouvelle reconversion ou promotion par alternance (PROA)',
  AF: 'Nouvelle Action de formation',
  FPE: 'Nouveau FE',
} as const
